import { useEffect, useState } from 'react'

import { IntroContainer } from 'components/intro-container'
import {
  Gradient,
  TitleContainer,
  Title,
  Subtitle,
} from 'components/intro-container/styled'
import backgroundL from './images/Background_L.webp'
import backgroundM from './images/Background_M.webp'
import backgroundS from './images/Background_S.webp'
import screen1L from './images/Screen1_L.webp'
import screen1M from './images/Screen1_M.webp'
import screen1S from './images/Screen1_S.webp'
import screen2L from './images/Screen2_L.webp'
import screen2M from './images/Screen2_M.webp'
import screen2S from './images/Screen2_S.webp'
import screen3L from './images/Screen3_L.webp'
import screen3M from './images/Screen3_M.webp'
import screen4L from './images/Screen4_L.webp'
import womenL from './images/Women_L.webp'
import womenM from './images/Women_M.webp'
import womenS from './images/Women_S.webp'
import {
  AnimationContainer,
  Background,
  Screen1,
  Screen2,
  Screen3,
  Screen4,
  Women,
} from './styled'
import { useAppContext } from 'context/app-context'

export const Animation = () => {
  const { setLoading, isPageVisible } = useAppContext()
  const [loadedImages, setLoadedImages] = useState(0)

  const onLoadImages = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoadedImages((loadedImages) => loadedImages + 1)
  }

  const startAnimation = () => {}

  useEffect(() => {
    if (loadedImages === 6) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImages])

  useEffect(() => {
    if (isPageVisible) {
      startAnimation()
    }
  }, [isPageVisible])

  return (
    <IntroContainer>
      <AnimationContainer>
        {/*
            <img className="celek" src={celek_L} />
            <img className="celek_M" src={celek_M} />
            <img className="celek_S" src={celek_S} />
            */}
        <picture>
          <source
            srcSet={backgroundS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={backgroundM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Background
            alt="background"
            src={backgroundL}
            onLoad={onLoadImages}
          />
        </picture>
        <picture>
          <source
            srcSet={screen1S}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={screen1M}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Screen1
            $ani={isPageVisible}
            alt="screen1"
            src={screen1L}
            onLoad={onLoadImages}
          />
        </picture>
        <picture>
          <source
            srcSet={screen2S}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={screen2M}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Screen2
            $ani={isPageVisible}
            alt="screen2"
            src={screen2L}
            onLoad={onLoadImages}
          />
        </picture>
        <picture>
          {/*<source srcSet={screen3S} media="(max-width: 520px)" type="image/webp" />*/}
          <source
            srcSet={screen3M}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Screen3
            $ani={isPageVisible}
            alt="screen3"
            src={screen3L}
            onLoad={onLoadImages}
          />
        </picture>
        <picture>
          {/*<source srcSet={screen4S} media="(max-width: 520px)" type="image/webp" />
          <source srcSet={screen4M} media="(max-width: 1024px)" type="image/webp" />*/}
          <Screen4
            $ani={isPageVisible}
            alt="screen4"
            src={screen4L}
            onLoad={onLoadImages}
          />
        </picture>
        <picture>
          <source
            srcSet={womenS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={womenM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Women
            $ani={isPageVisible}
            alt="women"
            src={womenL}
            onLoad={onLoadImages}
          />
        </picture>
      </AnimationContainer>
      <Gradient />
      <TitleContainer $hidden={isPageVisible}>
        <Title>"Мне казалось, что я хрупкая и беззащитная"</Title>
        <Subtitle>
          Как Улжан посадила насильника в тюрьму вопреки угрозам полиции и
          публичной травле
        </Subtitle>
      </TitleContainer>
    </IntroContainer>
  )
}
